import { get, post } from '@api/request';

export async function fetchDashboards(
  { queueService },
  authenticationToken,
  { type = 'All', groupBy = 'status', beginDt, endDt },
) {
  const url = `${queueService}/queue/dashboard/summary?definitionType=${type}&groupBy=${groupBy}&beginDt=${beginDt}&endDt=${endDt}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDashboardsByQueue(
  { queueService },
  authenticationToken,
  { type = 'All', groupBy = 'status', beginDt, endDt },
) {
  const url = `${queueService}/queue/dashboard/summary/byqueue?queueGroup=${type}&groupBy=${groupBy}&beginDt=${beginDt}&endDt=${endDt}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDashboardDetails(
  { queueService },
  authenticationToken,
  { queryString, beginDt, endDt },
) {
  // const url = `${queueService}/queue/dashboard/summary/detail?stateOrStatus=status&definitionType=Appeal&workItemSubType=Case Review&workItemStatus=Open`;
  const url = `${queueService}/queue/dashboard/summary/detail?${queryString}&beginDt=${beginDt}&endDt=${endDt}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDashboardQueueDetails(
  { queueService },
  authenticationToken,
  { queryString, beginDt, endDt },
) {
  const url = `${queueService}/queue/dashboard/summary/detail/byqueue?${queryString}&beginDt=${beginDt}&endDt=${endDt}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDashboardsByRole(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/dashboard/fetchbyrole`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDashboardQueryResults(
  { appraisalService },
  authenticationToken,
  { dashboardQueryID, page = 1, pageSize = 1000 },
) {
  const url = `${appraisalService}/dashboard/configuration/query/${dashboardQueryID}/execute?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function executeDashboard(
  { appraisalService },
  authenticationToken,
  { dashboardID },
) {
  const url = `${appraisalService}/dashboard/configuration/${dashboardID}/execute`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}
